export { CompareIcon } from "./compare";
